import { DashboardProps } from "./types/dashboardProps.d";
import DashboardWidgetDirectorAlerts from "./widgets/director/alerts.widget";
import DashboardWidgetDirectorDistricts from "./widgets/director/districts.widget";
import DashboardWidgetDirectorGeneral from "./widgets/director/general.widget";
import DashboardWidgetDirectorNotifications from "./widgets/director/notifications.widget";
import DashboardWidgetDirectorReports from "./widgets/director/reports.widget";
import DashboardWidgetDirectorTherapists from "./widgets/director/therapists.widget";
import DashboardWidgetHeaderNotification from "./widgets/header-notification.widget";
import DashboardWidgetTemplate from "./widgets/tbd.widget";

const DirectorDashboard = ({ discipline, user }: DashboardProps): JSX.Element => {
  return (
    <div className="dashboard directorDashboard">
      <div className="w-full">
        <DashboardWidgetHeaderNotification discipline={discipline} user={user} />
      </div>
      <div className="grid grid-cols-3">
        <div className="grid grid-cols-1">
          <DashboardWidgetDirectorDistricts discipline={discipline} user={user} />
          <DashboardWidgetDirectorTherapists discipline={discipline} user={user} />
        </div>
        <DashboardWidgetDirectorNotifications discipline={discipline} user={user} />
        <DashboardWidgetDirectorAlerts discipline={discipline} user={user} />
        <DashboardWidgetDirectorGeneral discipline={discipline} user={user} />
        <DashboardWidgetTemplate discipline={discipline} user={user} />
        <DashboardWidgetDirectorReports discipline={discipline} user={user} />
      </div>
    </div>
  );
};

export default DirectorDashboard;
